import { parse, format, } from "date-fns";
import { ptBR } from 'date-fns/locale';

export function moneyFormatter(value: any, allowZero = false) {
    if (!value || value < 0 || value == "")
        return allowZero ? "R$ 0,00" : "";

    const ret = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(value);

    return ret;
}

export function dateToHumanReadable(value: any) {
    if (!value)
        return '';

    const dateVal = parse(value, 'yyyy-MM-dd', new Date());
    return format(dateVal, 'PP', { locale: ptBR });
}

export function dateToShortHumanReadable(value: any) {
    if (value && value != "") {
        return new Intl.DateTimeFormat("pt-BR", {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric"

        }).format(Date.parse(value + (value.length > 10 ? "" : "T00:00:00Z")));
    }

    return "";

}

export enum PaginaCustomEnum {
    BRANCO = 1,
    CONTATO = 2,
    EMPRESA = 3
}

export const tipoPaginaCustomMap = {
    [PaginaCustomEnum.BRANCO]: {
        title: "Página em branco",
        subtitle: "Você criará todo o conteúdo do zero",
        icon: "mdi-file-document-outline",
    },
    [PaginaCustomEnum.CONTATO]: {
        icon: "mdi-card-account-phone",
        title: "Contato",
        subtitle: "Forneça os dados para contato",
    },
    [PaginaCustomEnum.EMPRESA]: {
        icon: "mdi-book-open-blank-variant",
        title: "Quem Somos",
        subtitle: "Apresente sobre a história, missão, visão, etc.",
    }
}

export function getTiposPaginasList() {
    return Object.keys(tipoPaginaCustomMap).map((el) => {
        return {
            id: +el,
            label: tipoPaginaCustomMap[el].title,
        };
    });
}

export function normalizeHttp(value: string) {
    if (!value) {
        return null;
    }

    if (value.includes("http")) {
        return value;
    }
    return `https://${value}`;
}

export function makeMailLink(value: string) {
    return `mailto:${value}`
}

export function makeWhatsappLink(value: string) {
    const normalizedNumero = value.replace(/\D/g, '');
    return `https://wa.me/${normalizedNumero}?text=${'Olá'}`;
}

export const situacaoPedidoMap = {
    EDICAO: { color: "statuspededit", text: "Edição" },
    REPLICACAO: { color: "statuspedreplicacao", text: "Pedido Criado" },
    APROVACAO: { color: "statuspedaprovacao", text: "Pendente" },
    PENDENTE: { color: "statuspedpendente", text: "Pendente" },
    ROMANEIO: { color: "statuspedromaneio", text: "Em Romaneio" },
    FATURADO: { color: "statuspedaprovado", text: "Faturado" },
    CANCELADO: { color: "statuspedcancelado", text: "Cancelado" },
};